import React, { useState } from 'react';
import TabsContainer from './PlanTabLeftSectionComponents/TabsContainer';
import UnscheduledTilesContainer from './PlanTabLeftSectionComponents/UnscheduledTilesContainer';
import SuggestedTilesContainer from './PlanTabLeftSectionComponents/SuggestedTilesContainer';

const PlanTabLeftSectionComponent = () => {
  const [activeTab, setActiveTab] = useState('unscheduled');

  const handleTabClick = tab => {
    setActiveTab(tab);
  };

  return (
    <div className="plan-tile-left-section">
      <TabsContainer activeTab={activeTab} handleTabClick={handleTabClick} />
      <UnscheduledTilesContainer activeTab={activeTab} />
      <SuggestedTilesContainer activeTab={activeTab} />
    </div>
  );
};

export default PlanTabLeftSectionComponent;
